/* eslint-disable react-hooks/exhaustive-deps */
import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useMemo, useLayoutEffect, useState, useEffect } from "react";
import useHierarquia from "~/fetchs/useHierarquia";
import usePrazoRegra from "~/fetchs/usePrazoRegra";
import { IconAlert } from "~misc/icons";

const ModalDescontoSimuladoNaoAprovado = ({ isOpen, onClose, onConfirm, onSave, simulacao, cliente }) => {
  const [isClienteProspect, setIsClienteProspect] = useState(!cliente?.codigo && cliente?.codigoProspect);

  const prazos = useMemo(() => {
    //simulacao
    let prazosListing = [];
    (simulacao?.gruposProduto || []).map((grupoProduto) => {
      (grupoProduto?.produtos || []).map((produto) => {
        const prazo = prazosListing.find((a) => a.grupoProdutoId == grupoProduto.grupoProdutoId ?? grupoProduto.grupoMaterialId)
        if (prazo && produto.prazoPagamentoId) {
          prazo.prazosPagamentoId.push(produto.prazoPagamentoId);
        }
        else {
          prazosListing.push({
            grupoProdutoId: grupoProduto.grupoProdutoId ?? grupoProduto.grupoMaterialId,
            prazosPagamentoId: [produto.prazoPagamentoId]
          })
        }
      })
    })
    return prazosListing;
  }, [simulacao]);

  const descontosMaximo = useMemo(() => {
    let biggers = [];
    (simulacao?.gruposProduto || []).map((grupoProduto) => {
      grupoProduto.produtos.map((produto) => {
        let maior = biggers.find((a) => a.grupoProdutoId == grupoProduto.grupoProdutoId ?? grupoProduto.grupoMaterialId);
        if (maior) {
          maior.descontos.push(produto.desconto.cif < produto.desconto.fob ? produto.desconto.cif : produto.desconto.fob)
        }
        else {
          biggers.push({
            grupoProdutoId: grupoProduto.grupoProdutoId ?? grupoProduto.grupoMaterialId,
            descontos: [produto.desconto.cif < produto.desconto.fob ? produto.desconto.cif : produto.desconto.fob],
          });
        }
      });
    });
    return biggers;
  }, [simulacao]);

  const { hierarquiasAprovacaoMaxima } = useHierarquia({
    descontosMaximo,
    prazos
  });

  const listaProdutosAprovacao = useMemo(() => {
    const produtos = [];

    (simulacao?.gruposProduto || []).forEach(gruposProduto => {
      const aprovadorMaximo = (hierarquiasAprovacaoMaxima || []).find(aprovadorMax => aprovadorMax?.grupoProdutoId === gruposProduto.grupoProdutoId);

      gruposProduto?.produtos?.forEach(produto => {
        if (!produto.enviadoAprovacao) {
          produtos.push({
            id: produto.produtoId,
            nome: produto.produto,
            aprovador: aprovadorMaximo?.hierarquia?.nome
          });
        }
      });
    });

    return produtos;
  }, [simulacao, hierarquiasAprovacaoMaxima]);


  useEffect(() => {
    if (cliente) {
      setIsClienteProspect(!cliente?.codigo && cliente?.codigoProspect);
    }
  }, [cliente]);


  const disabledPortalAprovacoes = useMemo(() => {
    return !listaProdutosAprovacao || !listaProdutosAprovacao.length || isClienteProspect;
  }, [listaProdutosAprovacao]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent className="!rounded-[20px]">
        <ModalHeader />
        <ModalCloseButton className="!bg-[#FF2E00] !text-white !top-0 !right-0 !rounded-b-none !rounded-tl-none !rounded-tr-[20px] !w-10 !h-10" />
        <ModalBody>
          {listaProdutosAprovacao && listaProdutosAprovacao.length ?
            (
              <>
                <IconAlert />
                <Text fontSize="2xl" align="center" className="text-quinaria mt-1">
                  Aviso!
                </Text>
                <Text
                  fontSize="xl"
                  className="font-bold text-center mx-auto"
                  maxWidth="300px"
                  mb="4"
                >
                  Os descontos simulados ainda não foram aprovados.
                </Text>
                <Table>
                  <Thead>
                    <Tr className="!bg-terciaria">
                      <Th className="!text-white !normal-case !font-normal !text-base !whitespace-normal !tracking-normal !text-center !py-2">
                        Produto
                      </Th>
                      <Th className="!text-white !normal-case !font-normal !text-base !whitespace-normal !tracking-normal !text-center !py-2">
                        Aprovador
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {(listaProdutosAprovacao || []).map(produto =>
                    (
                      <Tr key={produto.id} className="bg-[#E6E6E6]">
                        <Td className="!text-center !font-bold !font-base !py-2">
                          {produto.nome}
                        </Td>
                        <Td className="!text-center !font-bold !font-base !py-2">
                          {produto.aprovador}
                        </Td>
                      </Tr>
                    )
                    )}

                  </Tbody>
                </Table>
              </>
            )
            :
            (
              <>
                <Text fontSize="2xl" align="center" className="text-secundaria mt-1">
                  Aviso!
                </Text>
                <Text
                  fontSize="xl"
                  className="font-bold text-center mx-auto"
                  maxWidth="300px"
                  mb="4"
                >
                  Os preços desta proposta já estão vigentes para o cliente
                </Text>
              </>
            )}

          {isClienteProspect && (
            <Text fontSize="sm" align="center" className="text-quinaria mt-1">* Cliente prospect não pode ser enviado para o portal de aprovações!</Text>
          )}

          <div className="flex items-center justify-center gap-x-4 gap-y-4 md:grid-cols-1 lg:grid-cols-2 mt-6 pb-8">
            <button className="button-search flex justify-center items-center py-5 px-6 border-solid border-2 border-secundaria text-primaria hover:bg-primaria hover:text-white hover:border-primaria rounded-lg gap-1 font-bold text-lg "
              onClick={onSave}>
              Enviar sem aprovação
            </button>
            <button
              className={`button-search flex justify-center items-center py-5 px-10  ${disabledPortalAprovacoes ? 'bg-slate-50' : 'bg-secundaria'} text-primaria hover:text-white ${disabledPortalAprovacoes ? 'hover:bg-slate-50 text-black' : 'hover:bg-primaria rounded-lg gap-1 font-bold text-lg'}`}
              onClick={() => {
                onClose();
                onConfirm();
              }}
              disabled={disabledPortalAprovacoes}
            >
              Enviar para aprovação
            </button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalDescontoSimuladoNaoAprovado;
